import { render } from "./InputError.vue?vue&type=template&id=670ef42e"
import script from "./InputError.vue?vue&type=script&setup=true&lang=js"
export * from "./InputError.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/InputError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "670ef42e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('670ef42e', __exports__)) {
    api.reload('670ef42e', __exports__)
  }
  
  module.hot.accept("./InputError.vue?vue&type=template&id=670ef42e", () => {
    api.rerender('670ef42e', render)
  })

}


export default __exports__